"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var _react = _interopRequireDefault(require("react"));
var _Label = require("b2b-components/theme/components/Form/Label");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _Info = require("../../common/Info");
var _useCheckboxState = require("..//useCheckboxState");
var _CheckboxInput = require("../CheckboxInput");
require("./Checkbox.scss");
var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
    _ref$info = _ref.info,
    info = _ref$info === void 0 ? null : _ref$info,
    isChecked = _ref.isChecked,
    isDefaultChecked = _ref.isDefaultChecked,
    onChange = _ref.onChange,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isRemoveMode = _ref.isRemoveMode,
    isRemoveMode = _ref$isRemoveMode === void 0 ? false : _ref$isRemoveMode,
    className = _ref.className;
  var state = (0, _useCheckboxState.useCheckboxState)(isDefaultChecked, isChecked, onChange);
  var rootClassName = (0, _classnames["default"])('cds-Checkbox', className);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Label.Label, {
    className: rootClassName,
    onClick: state.onClick
  }, /*#__PURE__*/_react["default"].createElement(_CheckboxInput.CheckboxInput, {
    isChecked: state.isChecked,
    isDisabled: isDisabled,
    onChange: state.onChange,
    className: "cds-Checkbox-Input"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Checkbox-Field"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-Checkbox-Icon",
    name: isRemoveMode ? _Icon.ICON_NAME.checkmarkMixed : _Icon.ICON_NAME.checkmark
  })), label || ''), info && /*#__PURE__*/_react["default"].createElement(_Info.Info, {
    className: "cds-Checkbox-Info"
  }, info));
};
exports.Checkbox = Checkbox;